module.exports = __webpack_public_path__ + "media/B.124a0707.mp3";